export enum SessionStorageKeys {
  QuotePaymentIntent = 'quote-payment-intent',
  UserCredentials = 'userCreds',
  lfixSignInEmail = 'lfixSignInEmail',
  QuoteKey = 'quoteKey',
}

export const setSessionItem = (key: SessionStorageKeys, value: string) => {
  sessionStorage.setItem(key, value)
}

export const getSessionItem = (key: SessionStorageKeys): string | null => {
  return sessionStorage.getItem(key)
}

export const removeSessionItem = (key: SessionStorageKeys) => {
  sessionStorage.removeItem(key)
}
